import { render, staticRenderFns } from "./BrandsMarkets.vue?vue&type=template&id=16e00c6b&scoped=true&"
import script from "./BrandsMarkets.vue?vue&type=script&lang=js&"
export * from "./BrandsMarkets.vue?vue&type=script&lang=js&"
import style0 from "./BrandsMarkets.vue?vue&type=style&index=0&id=16e00c6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e00c6b",
  null
  
)

export default component.exports